import { ReactElement, ReactNode, useLayoutEffect } from 'react';

import { ThemeProvider } from '@material-ui/core';

import { ThemeVariantProvider } from '@spotify/confidence-core-react';

import { useBUITheme } from '../bui';
import { encoreDarkTheme } from './dark';
import { encoreLightTheme } from './light';

const ENCORE_CLASSES = ['encore-layout-themes', 'encore-medium-devices-theme'];

function useEncoreTheme(themeMode: 'light' | 'dark') {
  useLayoutEffect(() => {
    const colorClass = `encore-${themeMode}-theme`;
    const allClasses = [...ENCORE_CLASSES, colorClass];

    document.documentElement.setAttribute('data-theme-switching', '');
    document.documentElement.setAttribute('data-theme-variant', 'encore');
    document.documentElement.classList.add(...allClasses);

    let frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(() => {
        document.documentElement.removeAttribute('data-theme-switching');
      });
    });

    return () => {
      cancelAnimationFrame(frame);
      document.documentElement.removeAttribute('data-theme-switching');
      document.documentElement.removeAttribute('data-theme-variant');
      document.documentElement.classList.remove(...allClasses);
    };
  }, [themeMode]);
}

export const EncoreThemeProvider = ({
  children,
  mode,
}: {
  children: ReactNode;
  mode: 'light' | 'dark';
}): ReactElement => {
  useBUITheme(mode);
  useEncoreTheme(mode);

  return (
    <ThemeProvider theme={mode === 'dark' ? encoreDarkTheme : encoreLightTheme}>
      <ThemeVariantProvider variant={mode}>{children}</ThemeVariantProvider>
    </ThemeProvider>
  );
};
